import { render, staticRenderFns } from "./PlayerAttachments.vue?vue&type=template&id=c6e10986&scoped=true&"
import script from "./PlayerAttachments.vue?vue&type=script&lang=js&"
export * from "./PlayerAttachments.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAttachments.vue?vue&type=style&index=0&id=c6e10986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e10986",
  null
  
)

export default component.exports